import styles from "./index.module.css"

export default function Content(props) {
  return (
    <div className={`${styles.content} ${props.className || ""} ${props.noPadding ? "" : styles.default}`}>
      {props.children}
    </div>
  )
}